import './App.css';
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Dashboard from './component/pages/dashboard/Dashboard';
import UserList from './component/pages/user/UserList';
import AdminList from './component/pages/admin/AdminList';
import DeviceList from './component/pages/device/DeviceList';
import FirmwareList from './component/pages/firmware/FirmwareList';
import UserActionList from './component/pages/action/UserActionList';
import DeviceActionList from './component/pages/action/DeviceActionList';
import FirmwareActionList from './component/pages/action/FirmwareActionList';
import NoticeList from './component/pages/notice/NoticeList';
import FirmwareUpload from './component/pages/firmware/FirmwareUpload';
import NoticeForm from './component/pages/notice/NoticeForm';
import LoginForm from './component/pages/login/LoginForm';
import Topbar from './component/common/topbar/Topbar';
import { useSelector } from 'react-redux';
import Sidebar from './component/common/sidebar/Sidebar';
import AdminActionList from './component/pages/action/AdminActionList';
import LocActionList from './component/pages/action/LocActionList';
import MonthlyData from './component/pages/statistics/MonthlyData';

const PrivateRoute = (props) => {
  const { children } = props
  const authData = useSelector(state => state.auth);
  const location = useLocation();

  if(!sessionStorage.getItem("menu")) {
    sessionStorage.setItem("menu", "{}");
  }

  return (authData.isLoggedIn) ? (
    <>
      <Topbar/>
      <Sidebar />
        <div className="content">
          {/* <Sidebar /> */}
          <div></div>
          {children}
        </div>
    </>
  ) : (
    <Navigate  replace to="/login" state={{ from: location }}/>
  )
}

function App() {
  return (
    <>
      <Routes>
        {/* dashboard */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        {/* admin */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminList />
            </PrivateRoute>
          }
        />
        {/* user */}
        <Route
          path="/user"
          element={
            <PrivateRoute>
              <UserList />
            </PrivateRoute>
          }
        />
        {/* device */}
        <Route
          path="/device"
          element={
            <PrivateRoute>
              <DeviceList />
            </PrivateRoute>
          }
        />
        {/* firmware */}
        <Route
          path="/firmware"
          element={
            <PrivateRoute>
              <FirmwareList />
            </PrivateRoute>
          }
        />
        <Route
          path="/firmware/:id"
          element={
            <PrivateRoute>
              <FirmwareUpload />
            </PrivateRoute>
          }
        />
        <Route
          path="/firmware/upload"
          element={
            <PrivateRoute>
              <FirmwareUpload />
            </PrivateRoute>
          }
        />
        {/* action */}
        <Route
          path="/action/user"
          element={
            <PrivateRoute>
              <UserActionList />
            </PrivateRoute>
          }
        />
        <Route
          path="/action/device"
          element={
            <PrivateRoute>
              <DeviceActionList />
            </PrivateRoute>
          }
        />
        <Route
          path="/action/firmware"
          element={
            <PrivateRoute>
              <FirmwareActionList />
            </PrivateRoute>
          }
        />
        <Route
          path="/action/admin"
          element={
            <PrivateRoute>
              <AdminActionList />
            </PrivateRoute>
          }
        />
        <Route
          path="/action/location"
          element={
            <PrivateRoute>
              <LocActionList />
            </PrivateRoute>
          }
        />
        {/* statistics */}
        <Route
          path="/statistics"
          element={
            <PrivateRoute>
              <MonthlyData />
            </PrivateRoute>
          }
        />
        {/* notice */}
        <Route
          path="/notice"
          element={
            <PrivateRoute>
              <NoticeList />
            </PrivateRoute>
          }
        />
        <Route
          path="/notice/write"
          element={
            <PrivateRoute>
              <NoticeForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/notice/:id"
          element={
            <PrivateRoute>
              <NoticeForm />
            </PrivateRoute>
          }
        />
        {/* login */}
        <Route path="/login" element={<LoginForm />} />
      </Routes>
    </>
  );
}

export default App;
